import { FileCheck } from 'lucide-react';
import ModulePageHeading from '../../components/ModulePageHeading';
import { resolveApplicationNav } from '../../navigation/applicationNavigation';

function ApplyBwof() {
  return (
    <div>
      <ModulePageHeading
        resolveNav={resolveApplicationNav}
        title="Apply BWOF"
        infoTitle="Apply BWOF"
        infoChildren={
          <p>Building Warrant of Fitness application management. Full workflow screens will be added here.</p>
        }
      />
      <div className="bg-card rounded-lg shadow p-8 border border-gray-200">
        <div className="flex items-center gap-4 text-gray-500">
          <FileCheck className="w-12 h-12" />
          <p>Apply BWOF management content will be added here.</p>
        </div>
      </div>
    </div>
  );
}

export default ApplyBwof;
